<div class="partner-portal-showroom-guest-link-dialog-container">
  <button
    mat-icon-button
    class="close-btn"
    (click)="onClose()"
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
  <div class="title">Share this showroom!</div>
  <div class="subtitle">
    Use the link below to access your public showroom page that can be shared on your website and with prospective clients.
  </div>
  <div class="actions">
    <div class="link-wrapper">
      <mat-form-field
        class="link-field no-border"
        appearance="outline"
        color="accent"
      >
        <input
          class="link-input"
          matInput
          [ngModel]="link"
          readonly
        />
      </mat-form-field>
      <button
        class="copy-btn"
        mat-flat-button
        color="accent"
        (click)="onCopyClick()"
      >
        <span class="copy-btn-lbl">Copy</span>
      </button>
    </div>
    <button
      mat-stroked-button
      class="open-button"
      (click)="onOpenInNewTabClick()"
    >
      <mat-icon svgIcon="external_link"></mat-icon>
    </button>
  </div>
</div>
